<!-- Navbar -->
<app-navbar></app-navbar>

<!--Page Header-->
<div id="page-head" class="mb-10">
    <div class="container mx-auto">
        <h1>Form Submitted</h1>
    </div>
</div>

<!--Page Content-->
<div class="container mx-auto h-[100%]">
    <div class="flex items-center justify-center h-[100%]">
        <div>
            <div class="flex flex-col items-center space-y-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="text-green-600 w-28 h-28" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="1">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <h1 class="text-xl lg:text-3xl 2xl:text-4xl text-center font-bold custom-text-style">Your form has been successfully submitted.</h1>
                <button mat-flat-button color="primary" class="custom-home-btn" (click)="homeButton()">
                    <mat-icon>home</mat-icon>
                    Home
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Footer -->
<app-message></app-message>
<app-footer></app-footer>
